/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BelgeDto } from '../models/belge-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des Belges
 */
@Injectable({
  providedIn: 'root',
})
export class BelgesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation belgeGetList
   */
  static readonly BelgeGetListPath = '/api/belges/list';

  /**
   * Renvoie la liste des Belges.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `belgeGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  belgeGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<BelgeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, BelgesService.BelgeGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BelgeDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des Belges.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `belgeGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  belgeGetList(params?: {
  }): Observable<Array<BelgeDto>> {

    return this.belgeGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<BelgeDto>>) => r.body as Array<BelgeDto>)
    );
  }

  /**
   * Path part for operation belgeLoadList
   */
  static readonly BelgeLoadListPath = '/api/belges/load-list';

  /**
   * Renvoie la liste des Belges (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `belgeLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  belgeLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, BelgesService.BelgeLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des Belges (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `belgeLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  belgeLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.belgeLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation belgeGet
   */
  static readonly BelgeGetPath = '/api/belges/{id}';

  /**
   * Renvoie le Belge spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `belgeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  belgeGet$Response(params: {

    /**
     * Identifiant du Belge
     */
    id: number;
  }): Observable<StrictHttpResponse<BelgeDto>> {

    const rb = new RequestBuilder(this.rootUrl, BelgesService.BelgeGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BelgeDto>;
      })
    );
  }

  /**
   * Renvoie le Belge spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `belgeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  belgeGet(params: {

    /**
     * Identifiant du Belge
     */
    id: number;
  }): Observable<BelgeDto> {

    return this.belgeGet$Response(params).pipe(
      map((r: StrictHttpResponse<BelgeDto>) => r.body as BelgeDto)
    );
  }

  /**
   * Path part for operation belgePut
   */
  static readonly BelgePutPath = '/api/belges/{id}';

  /**
   * Met à jour le belge spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `belgePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  belgePut$Response(params: {

    /**
     * Identifiant le belge à mettre à jour
     */
    id: number;

    /**
     * Belge
     */
    body: BelgeDto
  }): Observable<StrictHttpResponse<BelgeDto>> {

    const rb = new RequestBuilder(this.rootUrl, BelgesService.BelgePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BelgeDto>;
      })
    );
  }

  /**
   * Met à jour le belge spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `belgePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  belgePut(params: {

    /**
     * Identifiant le belge à mettre à jour
     */
    id: number;

    /**
     * Belge
     */
    body: BelgeDto
  }): Observable<BelgeDto> {

    return this.belgePut$Response(params).pipe(
      map((r: StrictHttpResponse<BelgeDto>) => r.body as BelgeDto)
    );
  }

  /**
   * Path part for operation belgePost
   */
  static readonly BelgePostPath = '/api/belges';

  /**
   * Crée le Belge.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `belgePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  belgePost$Response(params: {

    /**
     * Belge
     */
    body: BelgeDto
  }): Observable<StrictHttpResponse<BelgeDto>> {

    const rb = new RequestBuilder(this.rootUrl, BelgesService.BelgePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BelgeDto>;
      })
    );
  }

  /**
   * Crée le Belge.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `belgePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  belgePost(params: {

    /**
     * Belge
     */
    body: BelgeDto
  }): Observable<BelgeDto> {

    return this.belgePost$Response(params).pipe(
      map((r: StrictHttpResponse<BelgeDto>) => r.body as BelgeDto)
    );
  }

  /**
   * Path part for operation belgeSetExclu
   */
  static readonly BelgeSetExcluPath = '/api/belges/{id}/exclu';

  /**
   * Change le paramètre EstExclu d'un Belge spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `belgeSetExclu()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  belgeSetExclu$Response(params: {

    /**
     * Identifiant du Belge
     */
    id: number;

    /**
     * Informations du belge
     */
    body: BelgeDto
  }): Observable<StrictHttpResponse<BelgeDto>> {

    const rb = new RequestBuilder(this.rootUrl, BelgesService.BelgeSetExcluPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BelgeDto>;
      })
    );
  }

  /**
   * Change le paramètre EstExclu d'un Belge spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `belgeSetExclu$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  belgeSetExclu(params: {

    /**
     * Identifiant du Belge
     */
    id: number;

    /**
     * Informations du belge
     */
    body: BelgeDto
  }): Observable<BelgeDto> {

    return this.belgeSetExclu$Response(params).pipe(
      map((r: StrictHttpResponse<BelgeDto>) => r.body as BelgeDto)
    );
  }

  /**
   * Path part for operation belgeDesactivate
   */
  static readonly BelgeDesactivatePath = '/api/belges/{id}/desactivate';

  /**
   * Désactive le Belge spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `belgeDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  belgeDesactivate$Response(params: {

    /**
     * Identifiant du Belge à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: BelgeDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, BelgesService.BelgeDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le Belge spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `belgeDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  belgeDesactivate(params: {

    /**
     * Identifiant du Belge à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: BelgeDto
  }): Observable<number> {

    return this.belgeDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation belgeSearchByName
   */
  static readonly BelgeSearchByNamePath = '/api/belges/name/{name}';

  /**
   * Recherche des Belges par leur nom (case-insensitive).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `belgeSearchByName()` instead.
   *
   * This method doesn't expect any request body.
   */
  belgeSearchByName$Response(params: {

    /**
     * Nom recherché (ou une partie du nom)
     */
    name: string;
  }): Observable<StrictHttpResponse<Array<BelgeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, BelgesService.BelgeSearchByNamePath, 'get');
    if (params) {
      rb.path('name', params.name, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BelgeDto>>;
      })
    );
  }

  /**
   * Recherche des Belges par leur nom (case-insensitive).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `belgeSearchByName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  belgeSearchByName(params: {

    /**
     * Nom recherché (ou une partie du nom)
     */
    name: string;
  }): Observable<Array<BelgeDto>> {

    return this.belgeSearchByName$Response(params).pipe(
      map((r: StrictHttpResponse<Array<BelgeDto>>) => r.body as Array<BelgeDto>)
    );
  }

  /**
   * Path part for operation belgeIsAlreadyExist
   */
  static readonly BelgeIsAlreadyExistPath = '/api/belges/isAlreadyExist';

  /**
   * Recherche des Belges par leur nom / prénom / date de naissance (case-insensitive).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `belgeIsAlreadyExist()` instead.
   *
   * This method doesn't expect any request body.
   */
  belgeIsAlreadyExist$Response(params?: {

    /**
     * Nom recherché
     */
    firstName?: string;

    /**
     * Prénom recherché
     */
    lastname?: string;

    /**
     * Date de naissance recherchée
     */
    birthday?: string;
  }): Observable<StrictHttpResponse<BelgeDto>> {

    const rb = new RequestBuilder(this.rootUrl, BelgesService.BelgeIsAlreadyExistPath, 'get');
    if (params) {
      rb.query('firstName', params.firstName, {});
      rb.query('lastname', params.lastname, {});
      rb.query('birthday', params.birthday, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BelgeDto>;
      })
    );
  }

  /**
   * Recherche des Belges par leur nom / prénom / date de naissance (case-insensitive).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `belgeIsAlreadyExist$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  belgeIsAlreadyExist(params?: {

    /**
     * Nom recherché
     */
    firstName?: string;

    /**
     * Prénom recherché
     */
    lastname?: string;

    /**
     * Date de naissance recherchée
     */
    birthday?: string;
  }): Observable<BelgeDto> {

    return this.belgeIsAlreadyExist$Response(params).pipe(
      map((r: StrictHttpResponse<BelgeDto>) => r.body as BelgeDto)
    );
  }

}
